var _path, _path2, _path3;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgUpiAr211(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 72,
    height: 36,
    viewBox: "0 0 72 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M57.4062 25.7416L65.9994 17.9026L61.9291 9.79297L57.4062 25.7416Z",
    fill: "#097939"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M54.5117 25.7416L63.1049 17.9026L59.0345 9.79297L54.5117 25.7416Z",
    fill: "#ED752E"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.4453 9.88144L9.82732 22.7664L22.6715 22.8564L26.1995 9.88144H29.4557L25.2257 24.9654C25.0637 25.5414 24.4469 26.0094 23.8487 26.0094H7.38533C6.38693 26.0094 5.79533 25.2294 6.06533 24.2694L10.0997 9.88144H13.4453ZM53.1545 9.79144H56.4107L51.8879 26.0094H48.5399L53.1545 9.79144ZM29.8181 16.5486L46.0997 16.4586L47.1857 13.0344H30.6317L31.6265 9.88084L49.2665 9.71884C50.3645 9.70864 51.0185 10.5588 50.7293 11.619L49.0673 17.6934C48.7775 18.753 47.6513 19.6116 46.5533 19.6116H31.9889L30.2717 26.2794H27.1037L29.8181 16.5486Z",
    fill: "#747474"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUpiAr211);
export default __webpack_public_path__ + "static/media/upi-ar21 1.927c5bce5162643f8f16694bfaceab01.svg";
export { ForwardRef as ReactComponent };